import { render, staticRenderFns } from "./FabricForm.vue?vue&type=template&id=2c2aed0b&scoped=true"
import script from "./FabricForm.vue?vue&type=script&lang=js"
export * from "./FabricForm.vue?vue&type=script&lang=js"
import style0 from "./FabricForm.vue?vue&type=style&index=0&id=2c2aed0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2aed0b",
  null
  
)

export default component.exports